import { STATUSES, STATUS_INDEX, STATUS_LABEL } from "../lib/constants";

export function StatusBar({ status, showLabel = true, compact = false }) {
  const idx = STATUS_INDEX[status] ?? 0;
  return (
    <div className={compact ? "" : "space-y-1.5"} data-testid="status-bar">
      <div className="status-segments">
        {STATUSES.map((s, i) => (
          <div
            key={s.value}
            className={`status-segment ${i <= idx ? `active-${status}` : ""}`}
            data-testid={`status-segment-${s.value}`}
          />
        ))}
      </div>
      {showLabel && (
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold tracking-wide text-foreground">
            {STATUS_LABEL[status]}
          </span>
          <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            {idx + 1}/{STATUSES.length}
          </span>
        </div>
      )}
    </div>
  );
}

export function PriorityChip({ priority }) {
  return (
    <span className={`chip chip-${priority}`} data-testid={`priority-chip-${priority}`}>
      {priority}
    </span>
  );
}
